import React from 'react'
import axios from 'axios'
import { connect, actions } from 'scripts/store'
import { DropDownNav, ProfileItem } from 'scripts/components/navigations/NavigationComponents'
import LoginDropdown from './LoginDropdown'
import Dropdown from 'scripts/components/navigations/dropdowns/Dropdown'
import IconProfile from 'fonticons/profile.svg'
import DefaultAvatar from 'images/soompi-default-avatar.png'
import Constants from 'scripts/base/Constants'
import locale from 'shared/i18n/react'
import cookie from 'react-cookies'

const presenceCookie = __SERVER_VAR_COOKIE_NAME__ // eslint-disable-line no-undef

export const profile = {
  get: () => {
    return new Promise(resolve => {
      axios.get('/users/session').then(response => {
        resolve(response.data)
      }).catch(e => {
        resolve({auth: Constants.Auth.NO})
      })
    })
  }
}
export class User extends React.Component {
  state = {auth: false, user: false}

  componentDidMount() {
    const sessionVal = cookie.load(presenceCookie)

    if (sessionVal && sessionVal === 'true') {
      actions.profile()
    } else {
      actions.nonLoggedInProfile()
    }
  }

  componentWillReceiveProps(nextProps) {
    if ((nextProps.auth === Constants.Auth.OK && nextProps.login) || (nextProps.auth === Constants.Auth.NO && nextProps.logout)) { // login || logout
      window.location.reload()
    } else if (nextProps.auth === Constants.Auth.OK && nextProps.user) {
      this.setState({auth: nextProps.auth, user: nextProps.user})
    } else if (nextProps.auth === Constants.Auth.ERR) {
      console.error('Login Error has occured.')
    } else {
      this.setState({auth: nextProps.auth, user: nextProps.user})
    }
  }

  loginWith = (provider) => {
    return actions.login(provider)
  }

  logout = () => {
    return actions.logout()
  }

  profileItem = (info) => {
    return (
      <ProfileItem
        imgAlt={info.displayName}
        className={info.className}
        imgSrc={info.image}
        username={info.displayName} />
    )
  }

  profileLoading = () => {
    return (
      <li className="navbar-profile nav-item-icon">
        <a href="javascript:;" className="navbar-link">
          <ProfileItem
            imgAlt=""
            className="loading"
            imgSrc={IconProfile}
            username="" />
        </a>
      </li>
    )
  }

  render() {
    const {auth, user} = this.state
    if (!auth && !user) {
      return this.profileLoading()
    }
    // lets wait for session
    let loginItems = []
    let info = {
      displayName: '',
      image: IconProfile,
      className: 'loggedout'
    }
    if (auth !== Constants.Auth.NO) {
      loginItems = [
        { name: locale.formatString(locale.profile.dropdownWelcomeTitle, user.displayName), type: 'text', link: '/', id: 'display-name' },
        { name: '', type: 'separator', link: '/', id: 'separator' },
        { name: locale.profile.edit, link: '/user/edit', id: 'profile' },
        { name: locale.logout.title, link: '/', callback: () => this.logout(), id: 'logout' }
      ]
      info = {
        displayName: '',
        image: user.image || DefaultAvatar,
        className: 'loggedin circle'
      }
    }
    return (
      <DropDownNav
        component={auth !== Constants.Auth.NO ? Dropdown : LoginDropdown}
        id='profile'
        dropdown='profile'
        linkComponent={this.profileItem(info)}
        dropDownList={loginItems} />
    )
  }
}

const mapToProps = ({auth, user, login, logout}) => {
  return {auth, user, login, logout}
}

export default connect(mapToProps)(User)



// WEBPACK FOOTER //
// ./assets/js/lib/firebase/user.jsx